import type { TIconProps } from "./types";

export const TelegramIcon = (props: TIconProps) => {
  return (
    <svg
      viewBox="0 0 26 26"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <g clipPath="url(#clip0_1104_564)">
        <path
          d="M13.0054 26.0108C20.1881 26.0108 26.0108 20.1881 26.0108 13.0054C26.0108 5.82272 20.1881 0 13.0054 0C5.82272 0 0 5.82272 0 13.0054C0 20.1881 5.82272 26.0108 13.0054 26.0108Z"
          fill="url(#paint0_linear_1104_564)"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M5.88001 12.8647C9.67009 11.2187 12.1932 10.125 13.4602 9.59435C17.0662 8.08914 17.8242 7.82925 18.3115 7.81842C18.4198 7.81842 18.658 7.84008 18.8204 7.97002C18.9504 8.07831 18.9829 8.21909 19.0045 8.32738C19.0262 8.43566 19.0479 8.66307 19.0262 8.83633C18.8313 10.8938 17.9866 15.8859 17.5535 18.1816C17.3694 19.1562 17.012 19.4811 16.6655 19.5135C15.9075 19.5785 15.3336 19.0154 14.608 18.539C13.4602 17.7918 12.8213 17.3261 11.7059 16.5898C10.4173 15.7451 11.2511 15.2795 11.9875 14.5215C12.1824 14.3265 15.5068 11.2945 15.5718 11.0238C15.5826 10.9913 15.5826 10.8613 15.5068 10.7963C15.431 10.7314 15.3227 10.753 15.2361 10.7747C15.117 10.7963 13.2977 12.0092 9.75672 14.4023C9.23694 14.7597 8.7713 14.933 8.34898 14.9221C7.88334 14.9113 6.99537 14.6622 6.32399 14.4457C5.51183 14.1858 4.8621 14.045 4.91624 13.5902C4.94873 13.3519 5.27359 13.1137 5.88001 12.8647Z"
          fill="white"
        />
      </g>
      <defs>
        <linearGradient
          id="paint0_linear_1104_564"
          x1={12.9946}
          y1={0}
          x2={12.9946}
          y2={25.8051}
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#2AABEE" />
          <stop offset={1} stopColor="#229ED9" />
        </linearGradient>
        <clipPath id="clip0_1104_564">
          <rect width={26} height={26} fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
};
